import { useContext } from "react";
import { UserContext } from "../../components/UserContext";
import "../../App.css";
import { Navigate } from "react-router-dom";
import AccountExperiencePage from "./AccountExperiencePage";

export default function AccountPage() {
  const { user, ready } = useContext(UserContext);

  if (!user) {
    return <Navigate to={"/"} />;
  }

  if (!ready) {
    return <div className="text-center py-12">Loading...</div>;
  }

  return (
    <div className="min-h-screen">
      <AccountExperiencePage />
    </div>
  );
}
